import { loginUrl } from '@/service/util';
import { getHostApi } from '@/utils';
import { getIsLogin } from '@/utils/cookie';
import request from '@/utils/request';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import { useGlobal } from '@/utils/useGlobal';
import { saveCookieForShopify, saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import ClipboardJS from 'clipboard';
import { useMemo, useRef } from 'react';
import EFPicture from '../EFPicture';
import {
    CouponCountdownDateType,
    CouponGiftProductItemType,
    CouponGiftType,
    CouponHitProductType,
    CouponType,
    FormatMoneyLocal,
    ShopifyCartItemType,
    ShopifyCartProps,
} from './const';
import { copyIcon, couponIcon, giftIcon } from './icon';
import css from './index.module.scss';

export default function ShopifyShoppingCart({ items, callback }: ShopifyCartProps) {
    const { useLang, useState, useRouter, useEffect, gtm, getSystemTime } = useGlobal();
    const { t } = useLang('shared');
    const { locale } = useRouter();
    const [carts, setCarts] = useState(JSON.parse(JSON.stringify(items)) as ShopifyCartItemType[]);
    const [focus, setFocus] = useState('');
    const [coupon, setCoupon] = useState({} as CouponType);
    const [copyed, setCopyed] = useState('');
    const [copyedGift, setCopyedGift] = useState(false);
    const [countdownDateObj, setCountdownDateObj] = useState({ d: '00', h: '00', m: '00', s: '00' } as CouponCountdownDateType);
    const sysTime = getSystemTime();
    let serverTime = sysTime; // 变
    const timer: any = useRef(null);
    const isLogin = getIsLogin();

    // 不能删，配合data-clipboard-text使用的对象
    const clipboard = typeof window !== 'undefined' ? new ClipboardJS(`.${css['shopify-shopping-cart']} .cart-coupon .coupon-code`) : null;

    const copyText = (cart: ShopifyCartItemType) => {
        setCopyed(cart?.variantId + (cart?.parentVariantId ? `_${cart?.parentVariantId}` : ''));
        let timer: any = setTimeout(() => {
            setCopyed('');
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        }, 2000);
    };

    const copyTextGift = () => {
        navigator.clipboard.writeText(coupon?.code || '');
        setCopyedGift(true);
        let timer: any = setTimeout(() => {
            setCopyedGift(false);
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        }, 2000);
    };
    // navigator.clipboard.writeText(value);

    const onVisibleChange = async () => {
        if (window.document.visibilityState === 'visible') {
            serverTime = getSystemTime();
            // 测试环境异常
            if (serverTime < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTime = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.error(e);
                    }
                })();
            }
        }
    };

    const AddSubtractor = ({ data, callback }: any) => {
        const NUM_MIN = 0;
        const NUM_MAX = data?.inventory ?? 1000;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 1);

        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_remove_from_cart',
                    product_name: data?.title,
                    price: data?.price || data?.discountPrice,
                    quantity: 1,
                    button_name: 'remove',
                    list_name: 'none',
                    tag: 'none',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const addNumber = () => {
            if (number >= NUM_MAX) return false;
            setNumber(number + 1);
            callback(data, number + 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    product_name: data?.title,
                    price: data?.price || data?.discountPrice,
                    quantity: 1,
                    button_name: 'add',
                    list_name: 'none',
                    tag: 'none',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v));
        };

        return (
            <div className="addSubtractor">
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    -
                </div>
                {/* <div className="addSubtractor-number">{number}</div> */}
                <input
                    className="addSubtractor-number"
                    autoFocus={focus === (data?.parentVariantId ? `${data?.parentVariantId}_${data?.variantId}` : data?.variantId)}
                    value={number}
                    onChange={inputChange}
                />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    +
                </div>
            </div>
        );
    };

    const handleCount = (data: any, num: number) => {
        console.log('data-num-', data, num);
        const newArr = JSON.parse(JSON.stringify(carts));
        const target: ShopifyCartItemType = newArr.find(
            (obj: any) => obj.variantId === data.variantId && (data?.parentVariantId ? data?.parentVariantId === obj?.parentVariantId : true),
        );
        if (num > 0) {
            target.quantity = num;
            setCarts(newArr);
            setFocus(data?.parentVariantId ? `${data?.parentVariantId}_${data?.variantId}` : data?.variantId);
            if (target?.parentVariantId) {
                callback(JSON.parse(JSON.stringify(newArr)), false, JSON.parse(JSON.stringify(target)));
            } else {
                callback(JSON.parse(JSON.stringify(newArr)), false, JSON.parse(JSON.stringify(target)));
            }
        } else {
            const restTargets: ShopifyCartItemType[] = newArr.filter(
                (obj: any) => !(obj.variantId === data.variantId && (data?.parentVariantId ? data?.parentVariantId === obj?.parentVariantId : true)),
            );
            setCarts(JSON.parse(JSON.stringify(restTargets)));
            callback(JSON.parse(JSON.stringify(restTargets)), false, JSON.parse(JSON.stringify({ ...target, quantity: 0 })));
        }
    };

    const handleClose = () => {
        const target = document.querySelector('.shopify-shopping-cart .cart-content.enter') as HTMLDivElement;
        if (target) {
            target.classList.remove('enter');
        }
        setTimeout(() => {
            callback(carts as ShopifyCartItemType[], true);
        }, 500);
    };

    const handleCheckout = () => {
        let prods = '';
        let temp = '';
        carts
            ?.filter((cart: any) => cart?.quantity > 0)
            ?.map((option: any, k: number) => {
                prods += `_${option?.title || option?.name}`;
                let tempVariantId = option?.variantId;
                option?.discountArr?.map((item: any) => {
                    if (item?.max !== 0) {
                        if (option?.quantity >= item?.min && option?.quantity <= item?.max) {
                            tempVariantId = item?.variantId;
                            return;
                        }
                    }
                    if (item?.max === 0 && item?.min !== 0) {
                        if (option?.quantity >= item?.min) {
                            tempVariantId = item?.variantId;
                            return;
                        }
                    }
                });
                temp += `${k > 0 ? ',' : ''}${tempVariantId}:${option?.quantity}`;
            });
        temp += '?channel=buy_button';
        try {
            /* 更改记录：
                https://project.feishu.cn/mz820/story/detail/4420981004
                https://ecoflow.feishu.cn/docx/Ej8SdCsC7o9SuixD0ITc3dpDnHc?from=from_copylink
                https://ecoflow.feishu.cn/docx/QFXkd9Eulo4xpnxe3Xnc33VKn5d?from=from_copylink

                2025-05-29 hzihhuang
                https://z6auztxon2.feishu.cn/docx/TI2TduxV0o5YGJxKxA8cDlCJnzg
            */
            // gtm.push({
            //     event: 'uaEvent',
            //     event_name: 'checkout',
            //     button_name: `${t('shopify_shopping_cart.checkout')}_${prods}`,
            // });
            const finalUrl = `https://${locale}.ecoflow.com/cart/${temp}`;

            saveAICookieForShopify(finalUrl, locale);

            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_checkout',
                button_name: t('shopify_shopping_cart.checkout'),
                type: 'none',
            });
        } catch (e) {
            console.error(e);
        } finally {
            const finalUrl = `https://${locale}.ecoflow.com/cart/${temp}`;
            saveCookieForShopify(finalUrl, locale);
            window.open(finalUrl, '_blank');
        }
    };

    const format = (time: number) => {
        const ts = Math.floor(time / 1000);
        const d = String(Math.floor(ts / 3600 / 24)).padStart(2, '0');
        const h = String(Math.floor((ts / 3600) % 24)).padStart(2, '0');
        const m = String(Math.floor((ts / 60) % 60)).padStart(2, '0');
        const s = String(Math.floor(ts % 60)).padStart(2, '0');
        setCountdownDateObj({ d, h, m, s });
    };

    useEffect(() => {
        if (carts?.length > 0 && isLogin && Object.keys(coupon).length > 0) {
            // 测试环境异常
            if (serverTime < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTime = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.error(e);
                    }
                })();
            }

            if (typeof window !== 'undefined') {
                window.document.addEventListener('visibilitychange', onVisibleChange);
            }

            if (coupon.startTime && coupon.endTime) {
                const [startTime, endTime] = [
                    new Date(`${coupon.startTime.replaceAll('-', '/')} GMT+8`).getTime(),
                    new Date(`${coupon.endTime.replaceAll('-', '/')} GMT+8`).getTime(),
                ];
                if (startTime < endTime && startTime <= serverTime && serverTime < endTime) {
                    format(endTime - serverTime);
                    timer.current = setInterval(() => {
                        format(endTime - serverTime);
                        serverTime += 1000;
                        if (serverTime >= endTime) {
                            clearInterval(timer.current);
                            timer.current = null;
                        }
                    }, 1000);
                }
            }

            return () => {
                clearInterval(timer.current);
            };
        }
    }, [coupon]);

    useEffect(() => {
        setTimeout(() => {
            const target = document.querySelector('.shopify-shopping-cart .cart-content') as HTMLDivElement;
            if (target) {
                target.classList.add('enter');
            }
        }, 0);
    }, [locale]);

    useEffect(() => {
        setCarts(JSON.parse(JSON.stringify(items)) as ShopifyCartItemType[]);
    }, [items]);

    useEffect(() => {
        // console.log('carts', carts);
        // 查询购物车优惠券 Dicount Coupon / 礼品卡 Gift Card
        const getCartCouponGift = async () => {
            const data: CouponGiftType = {
                source: 'CART',
                productList: carts.reduce((arr: CouponGiftProductItemType[], cart: ShopifyCartItemType) => {
                    arr.push({
                        price: Number(cart?.discountPrice),
                        quantity: cart?.quantity,
                        productId: cart?.productId,
                        variantId: cart?.variantId,
                    });
                    return arr;
                }, [] as CouponGiftProductItemType[]),
            };
            // console.log('data', data);
            try {
                const res = await request(`${loginUrl(locale)}/integral/web/rewardRedeemCoupon/cart/coupon/listForWeb`, {
                    method: 'POST',
                    data,
                    needToken: true,
                });
                // console.log('res', res);
                if (res?.code === '0') {
                    if (res?.data?.coupons?.length > 0) {
                        setCoupon(res?.data?.coupons[0]);
                    } else {
                        setCoupon({} as CouponType);
                    }
                }
            } catch (e) {
                console.error(e);
            }
        };
        if (isLogin && carts?.length > 0) {
            getCartCouponGift();
        }
    }, [carts]);

    const renderCountdown = useMemo(() => {
        return (
            <div className="coupon-countdown">
                <span className="coundown-text">{t('shopify_shopping_cart.countdown')}</span>
                <div className="countdown-time">
                    <div className="day-box date-list">
                        <span className="day date-number">{countdownDateObj?.d}</span>
                    </div>
                    <div className="hour-box date-list">
                        <span className="hour date-number">{countdownDateObj?.h}</span>
                    </div>
                    <div className="minute-box date-list">
                        <span className="minute date-number">{countdownDateObj?.m}</span>
                    </div>
                    <div className="second-box date-list">
                        <span className="second date-number">{countdownDateObj?.s}</span>
                    </div>
                </div>
            </div>
        );
    }, [countdownDateObj, coupon]);

    return (
        <div className={`${css['shopify-shopping-cart']} shopify-shopping-cart`}>
            <div className="cart-content">
                <span className="close" onClick={handleClose}>
                    <svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g>
                            <path id="Vector 1" d="M1 1L21 21" stroke="#757575" />
                            <path id="Vector 2" d="M21 1L1 21" stroke="#757575" />
                        </g>
                    </svg>
                </span>
                <p className="title">{t('shopify_shopping_cart.title')}</p>
                <div className={`cart-items ${coupon?.ruleType}`}>
                    {carts?.length <= 0 && <p className="no-items">{t('shopify_shopping_cart.nodata')}</p>}
                    {carts?.map((cart: ShopifyCartItemType) => {
                        const hitProduct: CouponHitProductType =
                            coupon?.hitProducts?.find((item: CouponHitProductType) => String(item?.variantId) === String(cart?.variantId)) || null;
                        return (
                            <div className="cart-item" key={`${cart?.parentVariantId ? `${cart?.parentVariantId}_` : ''}${cart.variantId}`}>
                                <div className="cart-top">
                                    <div className="cart-img">
                                        <EFPicture src={cart?.productImg || cart.img} alt={cart.title} aria-label={cart.title} />
                                    </div>
                                    <p className="cart-name">{cart.title}</p>
                                </div>
                                <div className="cart-bottom">
                                    <AddSubtractor data={cart} callback={handleCount} />
                                    <span className="cart-price">{FormatMoneyLocal(cart?.discountPrice, locale)}</span>
                                </div>
                                {coupon?.ruleType === 'COUPONS' && hitProduct && (
                                    <div className="cart-coupon">
                                        <div className="coupon-info">
                                            <div className="coupon-code" onClick={() => copyText(cart)} data-clipboard-text={coupon.code}>
                                                {couponIcon()}
                                                {copyed !== (cart?.parentVariantId ? `${cart.variantId}_${cart?.parentVariantId}` : cart?.variantId) && (
                                                    <span className="code-text">{'***'}</span>
                                                )}
                                                <span className="code-text">
                                                    {copyed === (cart?.parentVariantId ? `${cart.variantId}_${cart?.parentVariantId}` : cart?.variantId)
                                                        ? `${t('product.info.copyed')}`
                                                        : coupon.code?.slice(coupon.code?.length - 4)}
                                                </span>
                                                {copyIcon()}
                                            </div>
                                            <span className="coupon-discount">
                                                {'-'}
                                                {FormatMoneyLocal(hitProduct.discount, locale)}
                                            </span>
                                        </div>
                                        {renderCountdown}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
                {carts?.length > 0 && (
                    <>
                        <div className="checkout-box">
                            {coupon && coupon.amount && (
                                <>
                                    <div className="subtotal-price total-price">
                                        <span className="total">{t('shopify_shopping_cart.subtotal')}</span>
                                        <span className="price">
                                            {FormatMoneyLocal(
                                                carts.reduce((prev: number, curObj: ShopifyCartItemType) => {
                                                    return prev + (Number(curObj.discountPrice) * 100 * (curObj.quantity ?? 0)) / 100;
                                                }, 0),
                                                locale,
                                            )}
                                        </span>
                                    </div>
                                    <div className="discount-price total-price">
                                        <span className="total">
                                            {coupon.ruleType === 'COUPONS'
                                                ? t('shopify_shopping_cart.discount')
                                                : coupon.ruleType === 'GIFT_CARD'
                                                ? t('shopify_shopping_cart.gift')
                                                : ''}
                                        </span>
                                        {coupon.ruleType !== 'GIFT_CARD' && (
                                            <span className="price">
                                                {'-'}
                                                {FormatMoneyLocal(Number(coupon.discountAmount), locale)}
                                            </span>
                                        )}
                                    </div>
                                    {coupon.ruleType === 'GIFT_CARD' && (
                                        <div className="gift-card">
                                            <div className="gift-info">
                                                <div className="gift-code" onClick={copyTextGift} data-clipboard-text={coupon.code}>
                                                    {giftIcon()}
                                                    {!copyedGift && <span className="code-text">{'***'}</span>}
                                                    <span className="code-text">
                                                        {copyedGift ? `${t('product.info.copyed')}` : coupon.code?.slice(coupon.code?.length - 4)}
                                                    </span>
                                                    {copyIcon()}
                                                </div>
                                                <span className="gift-discount">
                                                    {'-'}
                                                    {FormatMoneyLocal(coupon?.discountAmount, locale)}
                                                </span>
                                            </div>
                                            {renderCountdown}
                                        </div>
                                    )}
                                </>
                            )}
                            <div className="total-price">
                                <span className="total">{t('shopify_shopping_cart.total')}</span>
                                <span className="price">
                                    {FormatMoneyLocal(
                                        carts.reduce((prev: number, curObj: ShopifyCartItemType) => {
                                            return prev + (Number(curObj.discountPrice) * 100 * (curObj.quantity ?? 0)) / 100;
                                        }, 0) - Number(coupon?.discountAmount || 0),
                                        locale,
                                    )}
                                </span>
                            </div>
                            <span className="checkout" onClick={handleCheckout}>
                                {t('shopify_shopping_cart.checkout')}
                            </span>
                        </div>
                    </>
                )}
            </div>

            <style jsx global>
                {`
                    #allContentContainer {
                        z-index: 101;
                    }
                `}
            </style>
        </div>
    );
}
